import { RootState } from "app/store";
import { EValidationSeverity, IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import { bcbs_config_attributeid_BCCAdmin, bcbs_config_attributeid_FeeType, FieldsToLookupByMasterAttributeId, IFlexibleFieldWithAttributes, pepmFeeType } from "global/Application";
import { ArrayToLookup, ArrayToLookupByPredicate, formatDate, Memoize, parseDate } from "global/Utility/TSFunctions";
import * as FAM from "model/FlexibleAttributeModel";
import { useHistory } from "react-router";

import { bcbs_config_release } from "model/AttributeOptionSets.type";
import { EDataValidationContext } from "./EDataValicationContext";
import { IDataValidationRules } from "./IDataValidationRules.type";

import * as CRMOptionSet from "model/AttributeOptionSets.type";


// fnp_bcbs_config_attribute_bcbs_name: string;
export interface ICoverageMapper {
    plan_attributeId: string;
    fnp_attributeId: string;
    fnp_fee_attributeId: string;
    fnp_fee_bccAdminCategory: string;
    fnp?: FAM.IFeesAndPremiums;
    fnp_fieldValue?: FAM.IBooleanValue | null;
    plan?: FAM.IPlan;
    plan_fieldValue?: FAM.IBooleanValue | null;
    fnp_fee?: FAM.IFlexibleFieldSet;
    fnp_fee_fieldValue?: FAM.INumberValue | null;
}

export const CoverageMapping: ICoverageMapper[] = [
    {
        // EE / CH - Coverage Levels (Plan - Dental) / EE / CH - Coverage Levels - Dental
        plan_attributeId: "f4be8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "ecc2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "eee9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {
        // EE / SP - Coverage Levels (Plan - Dental) / EE / SP - Coverage Levels - Dental
        plan_attributeId: "f6be8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "eec2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "f4e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Dental) / Employee + 1 (Child) - Coverage Levels - Dental
        plan_attributeId: "f8be8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "f0c2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "f5ea81fd-528b-ec11-93b0-000d3a5c81df",
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Dental) / Employee + 2 Dependents - Coverage Levels - Dental
        plan_attributeId: "fabe8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "f2c2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "86cc8433-538b-ec11-93b0-000d3a5c81df",
    },
    {

        // Family - Coverage Levels (Plan - Dental) / Family - Coverage Levels - Dental
        plan_attributeId: "fcbe8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "f4c2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "f2e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Single - Coverage Levels (Plan - Dental) / Single - Coverage Levels - Dental
        plan_attributeId: "febe8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "f6c2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "f0e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // TP - Coverage Levels (Plan - Dental) / TP - Coverage Levels - Dental
        plan_attributeId: "00bf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "f8c2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Dental",
        fnp_fee_attributeId: "f6e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // EE / CH - Coverage Levels (Plan - Vision) / EE / CH - Coverage Levels - Vision
        plan_attributeId: "02bf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "fac2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "eee9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // EE / SP - Coverage Levels (Plan - Vision) / EE / SP - Coverage Levels - Vision
        plan_attributeId: "04bf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "fcc2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "f4e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Vision) / Employee + 1 (Child) - Coverage Levels - Vision
        plan_attributeId: "06bf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "fec2201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "f5ea81fd-528b-ec11-93b0-000d3a5c81df",
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Vision) / Employee + 2 Dependents - Coverage Levels - Vision
        plan_attributeId: "08bf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "00c3201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "86cc8433-538b-ec11-93b0-000d3a5c81df",
    },
    {

        // Family - Coverage Levels (Plan - Vision) / Family - Coverage Levels - Vision
        plan_attributeId: "0abf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "02c3201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "f2e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Single - Coverage Levels (Plan - Vision) / Single - Coverage Levels - Vision
        plan_attributeId: "0cbf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "04c3201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "f0e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // TP - Coverage Levels (Plan - Vision) / TP - Coverage Levels - Vision
        plan_attributeId: "0ebf8932-be18-ed11-b83c-00224804e6b3",
        fnp_attributeId: "06c3201f-c318-ed11-b83c-00224804e9d1",
        fnp_fee_bccAdminCategory: "Vision",
        fnp_fee_attributeId: "f6e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // EE / CH - Coverage Levels (Plan - Medical) / EE / CH - Coverage Levels - Medical
        plan_attributeId: "8eb9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "3aeab0ef-e778-ec11-8d21-000d3a35957e",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "eee9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // EE / SP - Coverage Levels (Plan - Medical) / EE / SP - Coverage Levels - Medical
        plan_attributeId: "90b9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "3ceab0ef-e778-ec11-8d21-000d3a35957e",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "f4e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Employee + 1 (Child) - Coverage Levels (Plan - Medical) / Employee + 1 (Child) - Coverage Levels - Medical
        plan_attributeId: "92b9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "7457ffe0-5718-ed11-b83e-00224804e51f",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "f5ea81fd-528b-ec11-93b0-000d3a5c81df",
    },
    {

        // Employee + 2 Dependents - Coverage Levels (Plan - Medical) / Employee + 2 Dependents - Coverage Levels - Medical
        plan_attributeId: "94b9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "acd6d07a-5818-ed11-b83e-00224804e51f",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "86cc8433-538b-ec11-93b0-000d3a5c81df",
    },
    {

        // Family - Coverage Levels (Plan - Medical) / Family - Coverage Levels - Medical
        plan_attributeId: "96b9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "36eab0ef-e778-ec11-8d21-000d3a35957e",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "f2e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // Single - Coverage Levels (Plan - Medical) / Single - Coverage Levels - Medical
        plan_attributeId: "98b9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "38eab0ef-e778-ec11-8d21-000d3a35957e",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "f0e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
    {

        // TP - Coverage Levels (Plan - Medical) / TP - Coverage Levels - Medical
        plan_attributeId: "9ab9405c-5b18-ed11-b83c-00224804edc2",
        fnp_attributeId: "34eab0ef-e778-ec11-8d21-000d3a35957e",
        fnp_fee_bccAdminCategory: "Medical",
        fnp_fee_attributeId: "f6e9b0ef-e778-ec11-8d21-000d3a35957e",
    },
];


export const SharedValidations = (state: RootState, categories: IDataValidationRules, context: EDataValidationContext, history?: ReturnType<typeof useHistory>) => {

    const { checkUniqueName,
        checkRef,
        checkCoverage,
        checkGrandfathered,
        checkPlanGroupStructure,
        checkBillingOnlyPlan,
        checkRelease,
        checkRequiredFields,
        checkData,
    } = categories;

    const checkRelatedToGroupNumber = true

    const uniqueEntityNameValidations: IValidationMessage[] = [];
    const refValidations: IValidationMessage[] = [];
    const coverageValidations: IValidationMessage[] = [];
    const grandFatherValidations: IValidationMessage[] = [];
    const planGroupStructureValidations: IValidationMessage[] = [];
    const relatedToGroupNumberValidations: IValidationMessage[] = [];
    const billingOnlyPlanValidations: IValidationMessage[] = [];
    const dataValidations: IValidationMessage[] = [];
    const requiredFieldsValidations: IValidationMessage[] = [];

    let releaseValidations: IValidationMessage[] = [];

    const resultValidations = {
        refValidations,
        uniqueEntityNameValidations,
        coverageValidations,
        grandFatherValidations,
        planGroupStructureValidations,
        billingOnlyPlanValidations,
        releaseValidations,
        relatedToGroupNumberValidations,
        requiredFieldsValidations,
        dataValidations,
    };

    let planLookup: Record<string, FAM.IPlan> = {};
    let benefitLookup: Record<string, FAM.IBenefit> = {};
    let feesAndPremiumLookup: Record<string, FAM.IFeesAndPremiums> = {};
    let stopLossLookup: Record<string, FAM.IStopLoss> = {};
    let accountsReceivableLookup: Record<string, FAM.IAccountsReceivable> = {};
    let groupNumbersLookup: Record<string, FAM.IGroupNumber[]> = {};
    let CESLookup: Record<string, FAM.ICESNumber> = {};

    // entityFieldMasterAttributesLookup
    // field lookups by master attribute id
    // entityId -> {master_attribute_id -> [field1, field2, ...]}
    let _entityFieldsMemoLookup: Record<string, (...par: never[]) => Record<string, IFlexibleFieldWithAttributes[]>> = {};

    // Caching function to store the master attributes for each entity
    // entity -> {master_attribute_id -> [field1, field2, ...]}
    // creates a closure to store the master attributes for a given entity
    const getFieldsMemoByEntity = (entity: FAM.IFlexibleFieldSet | FAM.IFeesAndPremiums | FAM.IAccountsReceivable | FAM.IGroupNumber) => {
        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        let memo = _entityFieldsMemoLookup[entity.id];

        if (!memo)
            _entityFieldsMemoLookup[entity.id] = memo = Memoize(() => {
                return FieldsToLookupByMasterAttributeId(state.data.config, entity.fields);
            });

        return memo;
    };

    // {plan1_id -> [group_number_1, group_number2, ...]}
    // {stoploss1_id -> [group_number_1, group_number2, ...]}
    // {ar1_id -> [group_number_1, group_number2, ...]}
    const groupNumbersByPlanIdLookup: Record<string, { groupNumber: FAM.IGroupNumber, plan: FAM.IPlan }[]> = {};
    const groupNumbersByStopLossIdLookup: Record<string, { groupNumber: FAM.IGroupNumber, stopLoss: FAM.IStopLoss }[]> = {};
    const groupNumbersByAccountsReceivableIdLookup: Record<string, { groupNumber: FAM.IGroupNumber, accountsReceivable: FAM.IAccountsReceivable }[]> = {};

    type TRelation_AR_FNP = {
        accountsReceivable: FAM.IAccountsReceivable,
        feesAndPremium: FAM.IFeesAndPremiums,
        // last group number that has this relationship
        lastGroupNumber: FAM.IGroupNumber,
        plan: FAM.IPlan
    };

    let accountsReceivable_to_feesAndPremium_byId: Record<string, TRelation_AR_FNP> = {};

    let accountsReceivable_to_feesAndPremiums: Record<string, TRelation_AR_FNP[]> = {};


    // Coverage ----
    // planId -> CoverFields following coverage mapping layout
    const plansCoverageFields = {} as Record<string, typeof CoverageMapping>;
    const feesAndPremiumsCoverages = {} as Record<string, typeof CoverageMapping>;;

    // Group Structure ---- 
    // This may need optimizations
    const refGroupNumberCESValidation: IValidationMessage[] = [];
    const refGroupNumberPlanValidation: IValidationMessage[] = [];
    const refGroupNumberStopLossValidation: IValidationMessage[] = [];
    const refGroupNumberAccountsReceivableValidation: IValidationMessage[] = [];
    const refDepartmentCESValidation: IValidationMessage[] = [];

    // {plan1_id -> {ces_number_1 -> {group_number_1, group_number_2}, ces_number_2 -> ..., }
    const planToCesToGN: Record<string, Record<string, FAM.IGroupNumber>> = {}

    const statuscode = state.data.snapshot.statuscode;

    // Lookups -----------------------------------------------------
    planLookup = ArrayToLookup(state?.data?.json.plans);
    benefitLookup = ArrayToLookup(state?.data?.json.benefits);
    feesAndPremiumLookup = ArrayToLookup(state?.data?.json.feesAndPremiums);
    stopLossLookup = ArrayToLookup(state?.data?.json.stopLoss);
    accountsReceivableLookup = ArrayToLookup(state?.data?.json.claimsARs);
    groupNumbersLookup = {};
    CESLookup = ArrayToLookup(state?.data?.json.groupStructure.cesNumbers);


    state?.data?.json.groupStructure.groupNumbers.forEach(eachGroupNumber => {

        if (eachGroupNumber.planRef) {
            const foundPlan = planLookup[eachGroupNumber.planRef.id];

            if (foundPlan && !eachGroupNumber.deactivated && !foundPlan.deactivated) {
                const t = groupNumbersByPlanIdLookup[eachGroupNumber.planRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    plan: foundPlan
                });
                groupNumbersByPlanIdLookup[eachGroupNumber.planRef.id] = t;
            }
        }

        if (eachGroupNumber.stopLossRef) {
            const foundStopLoss = stopLossLookup[eachGroupNumber.stopLossRef.id];

            if (foundStopLoss && !eachGroupNumber.deactivated && !foundStopLoss.deactivated) {
                const t = groupNumbersByStopLossIdLookup[eachGroupNumber.stopLossRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    stopLoss: foundStopLoss
                });
                groupNumbersByStopLossIdLookup[eachGroupNumber.stopLossRef.id] = t;
            }
        }

        if (eachGroupNumber.accountsReceivableRef) {
            const foundAccountsReceivable = accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id];

            if (foundAccountsReceivable && !eachGroupNumber.deactivated && !foundAccountsReceivable.deactivated) {
                const t = groupNumbersByAccountsReceivableIdLookup[eachGroupNumber.accountsReceivableRef.id] ?? [];
                t.push({
                    groupNumber: eachGroupNumber,
                    accountsReceivable: foundAccountsReceivable,
                });
                groupNumbersByAccountsReceivableIdLookup[eachGroupNumber.accountsReceivableRef.id] = t;
            }
        }

        if (eachGroupNumber) {
            if (!eachGroupNumber.deactivated) {
                const gn = eachGroupNumber.groupNumber ?? '?'
                const t = groupNumbersLookup[gn] ?? [];
                t.push(eachGroupNumber);
                groupNumbersLookup[gn] = t;
            }
        }

        // Plan, FeesAndPremium, AccountsReceivable Relationship
        if (eachGroupNumber)
            if (!eachGroupNumber.deactivated) {

                const plan = eachGroupNumber?.planRef?.id ? planLookup[eachGroupNumber.planRef.id] : null;
                const feesAndPremium = plan?.feesAndPremiumsRef?.id ? feesAndPremiumLookup[plan.feesAndPremiumsRef.id] : null;
                const accountsReceivable = eachGroupNumber?.accountsReceivableRef?.id ? accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id] : null;

                if (plan && feesAndPremium && accountsReceivable) {

                    const obj: TRelation_AR_FNP = {
                        plan: plan,
                        feesAndPremium: feesAndPremium,
                        accountsReceivable: accountsReceivable,
                        lastGroupNumber: eachGroupNumber
                    }

                    accountsReceivable_to_feesAndPremium_byId[accountsReceivable.id + "/" + feesAndPremium?.id] = obj;

                    const fees = accountsReceivable_to_feesAndPremiums[accountsReceivable.id] ?? [];

                    // only add if feesAndPremium is not already in the list
                    if (fees.length === 0)
                        fees.push(obj);
                    else if (!fees.some(t => t.feesAndPremium.id === feesAndPremium.id))
                        fees.push(obj);

                    accountsReceivable_to_feesAndPremiums[accountsReceivable.id] = fees;
                }

            }
    });

    const snapshot_statuscode_post_uwrc =
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Gold Standard(808900006)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Underwriting Review Complete(2)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Data Entry Complete(808900000)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Retired(808900001)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['MNIL Underwriting Complete(808900004)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Merged and Closed(808900010)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Cancelled(808900011)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Transferred to Other LOB(808900012)'].value ||
        statuscode == CRMOptionSet.bcbs_groupconfigurationsnapshot.statuscode['Inactive(808900002)'].value;

    const validatedNonStandard = (
        entity: FAM.INonStandard,
        list: FAM.INonStandard[],
        parent:
            { groupConfiguration: FAM.IGroupConfigurationData } |
            { benefit: FAM.IBenefit }
    ) => {

        // Validation Edit - Some elements are sharing an identifier within the same context
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/382827
        // if (checkUniqueName)
        //     if (state.data.json.nonStandards.some(eachTest => eachTest.name === eachNS.name && eachTest !== eachNS)) {
        //         uniqueValidations.push({
        //             title: `Nonstandard (${eachNS.name}) on GroupConfiguration does not have a unique name.`,
        //             type: EValidationSeverity.warn,
        //             description: `Nonstandard id: ${eachNS.id}`,
        //         });
        //     }

    }

    const validateAttributeSet = (
        entity: FAM.IFlexibleFieldSet,
        list: FAM.IFlexibleFieldSet[],
        parent:
            { type: 'groupConfiguration', groupConfiguration: FAM.IGroupConfigurationData } |
            { type: 'benefit', benefit: FAM.IBenefit } |
            { type: 'feesAndPremium', feesAndPremium: FAM.IFeesAndPremiums } |
            { type: 'stopLoss', stopLoss: FAM.IStopLoss } |
            { type: 'accountsReceivable', accountsReceivable: FAM.IAccountsReceivable }
    ) => {

        // TODO replace fields with EntityFieldsMemoized and test
        const fieldsMemo = Memoize(() => {
            return FieldsToLookupByMasterAttributeId(state.data.config, entity.fields);
        })

        // Validation Edit - Some elements are sharing an identifier within the same context
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/382827
        // if (checkUniqueName)
        //     if (state.data.json.attributeSets.some(eachTest => eachTest.name === eachAS.name && eachTest !== eachAS)) {
        //         uniqueValidations.push({
        //             title: `AttributeSet (${eachAS.name}) on GroupConfiguration does not have a unique name.`,
        //             type: EValidationSeverity.warn,
        //             description: `AttributeSet id: ${eachAS.id}`,
        //         });
        //     }

        // ITS Facility/ITS Professional
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/504010
        if (checkRequiredFields)
            if (!entity.deactivated)
                if (parent.type === 'benefit') {

                    // Custom Network / Attribute Set
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=4cd7c5a7-d590-ec11-b400-0022480a93ed
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=f1646443-d590-ec11-b400-0022480a93ed
                    if (entity.attributeSetRef.id === "f1646443-d590-ec11-b400-0022480a93ed") {

                        // Network Filing Method
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=29130b39-8bb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=125833f0-8ab3-ed11-83fe-000d3a305861
                        const bcbs_networkfilingmethod = fieldsMemo()['125833f0-8ab3-ed11-83fe-000d3a305861'];

                        const bcbs_networkfilingmethod_value = bcbs_networkfilingmethod[0].field.values?.[0].value?.type === 'entity'
                            ? bcbs_networkfilingmethod[0].field.values?.[0].value
                            : undefined;

                        // Question) is it enabled for ITS ?
                        // ITS : id = c5ce2ee2-8bb3-ed11-83fe-000d3a305861
                        // ITS Spin-Off: id = 7e28d81e-8cb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=c5ce2ee2-8bb3-ed11-83fe-000d3a305861
                        // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_optionsetitem&id=7e28d81e-8cb3-ed11-83fe-000d3a305861
                        // Update: disabled for ITS Spin-Off, see https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/555682
                        const isITS = bcbs_networkfilingmethod_value?.id === 'c5ce2ee2-8bb3-ed11-83fe-000d3a305861' 

                        if (isITS) {

                            // ITS Facility Network Pricing
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=13b3b141-040f-ef11-9f89-6045bdeb64f8
                            const bcbs_itsfacilitynetworkpricing = fieldsMemo()['13b3b141-040f-ef11-9f89-6045bdeb64f8'];
                            const bcbs_itsfacilitynetworkpricing_value = bcbs_itsfacilitynetworkpricing[0].field.values?.[0].value?.type === 'entity'
                                ? bcbs_itsfacilitynetworkpricing[0].field.values?.[0].value
                                : null;

                            // ITS Professional Network Pricing
                            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=686ea39f-050f-ef11-9f89-6045bdeb64f8
                            const bcbs_itsprofessionalnetworkpricing = fieldsMemo()['686ea39f-050f-ef11-9f89-6045bdeb64f8'];
                            const bcbs_itsprofessionalnetworkpricing_value = bcbs_itsprofessionalnetworkpricing[0].field.values?.[0].value?.type === 'entity'
                                ? bcbs_itsprofessionalnetworkpricing[0].field.values?.[0].value
                                : null;

                            // checked both facility and professional, they are sharing the same option set item
                            // Rule : ITS Facility and ITS Professional are both set to NOT APPLICABLE
                            // One of ITS Facility and ITS Professional is set to NOT APPLICABLE and the other is Null
                            // Both are Null

                            // name: not applicable - id: 5f770a51-050f-ef11-9f89-6045bdeb64f8
                            // null/blank

                            // Question) either null or both not applicable ?
                            if (
                                (bcbs_itsprofessionalnetworkpricing_value?.id === '5f770a51-050f-ef11-9f89-6045bdeb64f8'
                                    && bcbs_itsfacilitynetworkpricing_value?.id === '5f770a51-050f-ef11-9f89-6045bdeb64f8')
                                || (bcbs_itsprofessionalnetworkpricing_value === null
                                    || bcbs_itsfacilitynetworkpricing_value === null)
                            ) {
                                requiredFieldsValidations.push({
                                    title: `Conflicting or Incomplete ITS Fields.`,
                                    type: EValidationSeverity.error,
                                    description: `'ITS Facility' and 'ITS Professional' cannot both be marked as 'Not Applicable' in the same Attribute Set or left unselected\nPlease review and correct the entries.\nBenefit (${parent.benefit.name}) > Custom Networks (${entity.name})`,
                                });
                            }
                        }

                    }
                }
    }

    // Group Configuration | Fields
    // -------------------------------------------------------
    if (checkRequiredFields) {
        const fields = ArrayToLookupByPredicate(state?.data?.json.fields, t => t.configRef.id);

        // Initial Enrollment
        // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=cea36909-d05d-ec11-8f8f-000d3a5a062b
        const bcbs_initialenrollment = fields['cea36909-d05d-ec11-8f8f-000d3a5a062b'];

        // Ongoing (Normal) Enrollment
        // https://bcbsonline.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=10a46909-d05d-ec11-8f8f-000d3a5a062b
        const bcbs_normalenrollment = fields['10a46909-d05d-ec11-8f8f-000d3a5a062b'];

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/453284
        // The Initial Enrollment and Ongoing Enrollment Types must be completed in order for E&M Tasks to generate
        // User should not be able to mark the Configuration as DEC until the fields are populated.
        if (!bcbs_initialenrollment.values?.[0].value?.type)
            requiredFieldsValidations.push({
                title: `Initial Enrollment field must be completed to proceed.`,
                type: EValidationSeverity.error,
                description: `The Initial Enrollment must be completed in order for E&M Tasks to generate and for E&M to know how Enrollment will be received.`,
            });

        if (!bcbs_normalenrollment.values?.[0].value?.type)
            requiredFieldsValidations.push({
                title: `Ongoing Enrollment fields must be completed to proceed.`,
                type: EValidationSeverity.error,
                description: `The Ongoing Enrollment Types must be completed in order for E&M Tasks to generate and for E&M to know how Enrollment will be received.`,
            });

    }

    // Group Configuration | NonStandards
    // -------------------------------------------------------
    state.data.json.nonStandards.forEach(eachNonStandard => {
        validatedNonStandard(
            eachNonStandard,
            state.data.json.nonStandards,
            { groupConfiguration: state.data.json }
        )
    });

    // Group Configuration | Attributeset ?
    // -------------------------------------------------------
    state.data.json.attributeSets.forEach(eachAttributeSet => {
        validateAttributeSet(
            eachAttributeSet,
            state.data.json.attributeSets,
            { type: 'groupConfiguration', groupConfiguration: state.data.json }
        )
    });

    // Plans
    // -------------------------------------------------------
    state?.data?.json.plans.forEach(eachPlan => {

        // lets only build this if needed for the context
        let fieldMap: Record<string, FAM.IFlexibleField> | null = null;

        if (!fieldMap)
            if (checkCoverage)
                fieldMap = ArrayToLookupByPredicate(eachPlan.fields, (t) => t.configRef.id);

        // feesAndPremiumsRef unique name check
        if (checkUniqueName)
            if (state.data.json.plans.some(eachTest => eachTest.name === eachPlan.name && eachTest !== eachPlan)) {
                uniqueEntityNameValidations.push({
                    title: `Plan (${eachPlan.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Plan id: ${eachPlan.id}`,
                });
            }

        // feesAndPremiumsRef reference check
        if (checkRef)
            if (eachPlan.feesAndPremiumsRef) {
                const matchingFNP = feesAndPremiumLookup[eachPlan?.feesAndPremiumsRef?.id];

                if (!matchingFNP)
                    refValidations.push({
                        title: `Plan (${eachPlan.name}) is referencing an invalid Fees And Premium (${eachPlan?.feesAndPremiumsRef?.name ?? 'N/A'}).`,
                        type: EValidationSeverity.error,
                        description: `Plan id: ${eachPlan.id}\r\nFees and Premium id${eachPlan?.feesAndPremiumsRef.id}`,
                    });

                if (matchingFNP && matchingFNP.deactivated)
                    refValidations.push({
                        title: `Plan (${eachPlan.name}) is referencing a deactivated Fees And Premium (${eachPlan?.feesAndPremiumsRef?.name ?? 'N/A'}).`,
                        type: EValidationSeverity.error,
                        description: `Plan id: ${eachPlan.id}\r\nFees and Premium id:${eachPlan?.feesAndPremiumsRef.id}`,
                    });
            }

        // does it have FNP reference?
        if (checkCoverage)
            if (!eachPlan.deactivated)
                if (eachPlan.feesAndPremiumsRef && fieldMap) {

                    const coverageMap = CoverageMapping.map(t => {

                        const tt: ICoverageMapper = {
                            ...t,
                            plan: eachPlan,
                            plan_fieldValue: null,
                        };

                        const field = fieldMap![t.plan_attributeId];
                        if (field && field.values && field.values.length > 0) {
                            const fieldValue = (field.values[0].value as FAM.IBooleanValue);

                            if (fieldValue)
                                tt.plan_fieldValue = fieldValue;
                        }

                        return tt;
                    });

                    plansCoverageFields[eachPlan.id] = coverageMap;
                }

        // benefit reference check
        if (eachPlan.benefitRefs && eachPlan.benefitRefs.length > 0) {

            eachPlan.benefitRefs.forEach(eachPlanBenefit => {
                if (checkRef) {

                    const foundBenefit = benefitLookup[eachPlanBenefit.id];

                    if (!foundBenefit) {
                        refValidations.push({
                            title: `Plan (${eachPlan.name}) is referencing an invalid Benefit (${eachPlanBenefit?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Plan id: ${eachPlan.id}\r\nBenefit id${eachPlanBenefit?.id}`,
                        });
                    }

                    if (foundBenefit && foundBenefit.deactivated) {
                        refValidations.push({
                            title: `Plan (${eachPlan.name}) is referencing a deactivated Benefit (${foundBenefit?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Plan id: ${eachPlan.id}\nBenefit id${foundBenefit?.id}`,
                        });
                    }
                }

                if (!eachPlan.deactivated)
                    if (checkGrandfathered) {
                        const foundBenefit = benefitLookup[eachPlanBenefit.id];

                        // GF/NGF Benefit to Plan Mismatch
                        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/341091
                        if (foundBenefit && !foundBenefit.deactivated) {
                            if (!!eachPlan.grandFathered?.value && !!foundBenefit.grandFathered?.value) {
                                if (foundBenefit.bcbs_isgrandfatherenabled)
                                    if (foundBenefit.grandFathered?.value !== eachPlan.grandFathered?.value) {

                                        grandFatherValidations.push({
                                            title: `Plan (${eachPlan.name}) and Benefit (${foundBenefit?.name ?? 'N/A'}) GF/NGF miss match detected.`,
                                            type: EValidationSeverity.error,
                                            description: `Plan GF/NGF: ${eachPlan?.grandFathered?.name}\nBenefit GF/NGF: ${foundBenefit?.grandFathered?.name}`,
                                            // onRenderDescription: OnRenderDescriptionValidationItem(
                                            //     <Stack horizontal tokens={{ childrenGap: '15px' }}>
                                            //         <PlanCard
                                            //             key={eachPlan.id}
                                            //             plan={eachPlan}
                                            //             onClick={() => history?.push(AppLinkTo(state, { id: eachPlan.id, type: 'plan' }))}
                                            //             state={state}
                                            //         />
                                            //         <BenefitCard
                                            //             key={foundBenefit.id}
                                            //             benefit={foundBenefit}
                                            //             state={state}
                                            //             mode={EBenefitCardFunction.display}
                                            //             onClick={() => { history?.push(AppLinkTo(state, { id: foundBenefit.id, type: 'benefit', parent: { id: eachPlan.id, type: 'plan' } })); }}
                                            //         />
                                            //     </Stack>
                                            // ),
                                        });
                                    }

                            }

                        }
                    }

            });

        }

        // Billing Only Plan validation - Apply validation edits to ensure proper Plan building
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/373830
        if (checkBillingOnlyPlan)
            if (!eachPlan.deactivated) {

                const billingOnly = eachPlan.billingOnlyPlan;
                const hasBenefit = eachPlan.benefitRefs.length > 0;
                const hasGroupNumber = groupNumbersByPlanIdLookup[eachPlan.id]?.length > 0 ?? false;

                if (!billingOnly && !hasBenefit) {
                    billingOnlyPlanValidations.push({
                        title: `A non-billing Plan (${eachPlan.name}) has no Benefits.`,
                        type: EValidationSeverity.error,
                    });
                }

                if (!billingOnly && !hasGroupNumber) {
                    billingOnlyPlanValidations.push({
                        title: `A non-billing Plan (${eachPlan.name}) has no Group Numbers.`,
                        type: EValidationSeverity.warn,
                    });
                }

                if (billingOnly && hasBenefit) {
                    billingOnlyPlanValidations.push({
                        title: `A Billing Only Plan (${eachPlan.name}) has benefits.`,
                        type: EValidationSeverity.error,
                    });
                }

                if (billingOnly && !hasGroupNumber) {
                    billingOnlyPlanValidations.push({
                        title: `A Billing Only Plan (${eachPlan.name}) has no Group Numbers.`,
                        type: EValidationSeverity.error,
                    });
                }

            }
    });

    // Benefits
    // -------------------------------------------------------
    state?.data?.json.benefits.forEach(eachBenefit => {

        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        const getFieldsMemo = getFieldsMemoByEntity(eachBenefit);

        const getTiersMemo = Memoize(() => {
            return ArrayToLookupByPredicate(eachBenefit.tiers ?? [], t => t.id);
        })

        if (checkUniqueName)
            if (state.data.json.benefits.some(eachTest => eachTest.name === eachBenefit.name && eachTest !== eachBenefit)) {
                uniqueEntityNameValidations.push({
                    title: `Benefit (${eachBenefit.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Benefit id: ${eachBenefit.id}`,
                });
            }

        if (checkData) {
            if (!eachBenefit.deactivated) {
                // medical benefit ?
                if (eachBenefit.bcbs_config_categoryid === state.data.config.cache.map_bcbs_config_category_named['Medical'].bcbs_config_categoryid) {

                    // ABA Therapy pays at:
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2652723e-f777-ec11-8d21-000d3a5b9199
                    // * This has tier split
                    // * This has no pcp/specialist split
                    const bcbs_abatherapypayat = getFieldsMemo()['2652723e-f777-ec11-8d21-000d3a5b9199']?.[0]?.field?.values;

                    bcbs_abatherapypayat.forEach(eachValue => {
                        if (eachValue.tierRef?.id) {
                            const tier = getTiersMemo()[eachValue.tierRef.id];

                            // bcbs_copaycoinoption
                            // Not Covered, id = f01e8a49-d1c0-df11-992a-000c29d4337a

                            // if users enter "Not Covered" in Tiers 1-3 and INN 
                            if (eachValue.value?.type === 'entity' && eachValue?.value?.id === 'f01e8a49-d1c0-df11-992a-000c29d4337a') {
                                if (tier.name !== "Out of Network")
                                    dataValidations.push({
                                        title: `"Not Covered" is not a valid selection for ABA Network Benefits.`,
                                        type: EValidationSeverity.error,
                                        description: `ABA therapy has been reinstated as a tiered attribute. If you select "Not Covered" for Tiers or INN, the system will prevent submission.\n\nBenefit: ${eachBenefit.name}\nTier: ${tier?.name}`,
                                        // onRenderDescription: () => {
                                        //     return <Stack tokens={{ childrenGap: '10px' }} styles={{ root: { padding: '5px', paddingTop: '20px' } }}>
                                        //         <Stack.Item>
                                        //             <Stack>
                                        //                 <Text>
                                        //                     ABA therapy has been reinstated as a tiered attribute. If you select "Not Covered" for Tiers or INN, the system will prevent submission.
                                        //                 </Text>
                                        //             </Stack>
                                        //         </Stack.Item>
                                        //         <Stack.Item>
                                        //             <Text variant="small">
                                        //                 {`Benefit (${eachBenefit.name}) > ABA Therapy Pay At (${tier?.name})`}
                                        //             </Text>
                                        //         </Stack.Item>
                                        //         {/* <Stack.Item align="end">
                                        //         <Stack horizontal tokens={{ childrenGap: '10px' }}>
                                        //             <Text variant="small">
                                        //                 <Link onClick={() => {

                                        //                     // Example Route :
                                        //                     // groupConfiguration/52047332-605e-ef11-bfe3-000d3a9d4961/benefit/9d22cb36-dbda-4976-880f-4056093ff07f/tab/a2df6811-0c43-ec11-8c60-000d3a5b8f01/section/e385526f-7f75-ec11-8941-000d3a3527e6/field/?navigation=complete
                                        //                     let route = AppLinkTo(state,
                                        //                         {
                                        //                             id: "8e0316f6-7378-ec11-8d21-000d3a34c462", type: 'field',
                                        //                             parent: {
                                        //                                 id: "e385526f-7f75-ec11-8941-000d3a3527e6", type: 'section',
                                        //                                 parent: {
                                        //                                     id: "a2df6811-0c43-ec11-8c60-000d3a5b8f01", type: 'tab',
                                        //                                     parent: {
                                        //                                         id: eachBenefit.id, type: 'benefit'
                                        //                                     }
                                        //                                 }
                                        //                             }
                                        //                         },
                                        //                     );

                                        //                     route = route + '?navigation=pending';
                                        //                     history?.push(route)
                                        //                 }}>
                                        //                     Benefit ({eachBenefit.name})
                                        //                 </Link>
                                        //             </Text>
                                        //         </Stack>
                                        //     </Stack.Item> */}
                                        //     </Stack>
                                        // }
                                    });
                            }

                        }
                    });
                }
            }
        }

        // Validation Edit - Display a hard edit when the Subgroup or Benefit Cancellation Effective Date does not match the Effective Date of the Configuration
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/502867
        if (checkData) {
            if (!eachBenefit.deactivated) {
                if (eachBenefit.status.value === FAM.EBenefitStatus.Cancelled) {
                    // individual benefits get their own cancellation field and also users can add custom benefits for cancellation
                    for (const key in state.data.config.cache.map_bcbs_config_masterattribute_cancellations) {
                        const bcbs_cancellation = getFieldsMemo()[key];
                        if (bcbs_cancellation) {

                            const bcbs_cancellation_value = bcbs_cancellation[0].field.values?.[0].value?.type === 'date'
                                ? bcbs_cancellation[0].field.values?.[0].value
                                : undefined;

                            const snapshotEffectiveDate = state.data.json.effectiveDate?.value;
                            const benefitEffectiveDate = bcbs_cancellation_value?.value;

                            const benefitEffectiveDateValue = benefitEffectiveDate
                                ? formatDate(parseDate(benefitEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                                : "(blank)";

                            const snapshotEffectiveDateValue = snapshotEffectiveDate
                                ? formatDate(parseDate(snapshotEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                                : "(blank)";

                            if (snapshotEffectiveDate !== benefitEffectiveDate) {
                                dataValidations.push({
                                    title: `The Benefit Cancellation Effective Date must match the Group Configuration Effective Date.`,
                                    type: EValidationSeverity.error,
                                    description: `Group Configuration Effective Date: ${snapshotEffectiveDateValue}\nBenefit: ${eachBenefit.name}\nCancellation Effective Date: ${benefitEffectiveDateValue}`,
                                });
                            }

                        }
                    }
                }
            }
        }

        eachBenefit.attributeSets.forEach(eachAttributeSet => {
            validateAttributeSet(eachAttributeSet, eachBenefit.attributeSets, { type: 'benefit', benefit: eachBenefit });
        });

        eachBenefit.nonStandards.forEach(eachNonstandard => {
            validatedNonStandard(eachNonstandard, eachBenefit.nonStandards, { benefit: eachBenefit });
        });

    });

    // Group Structure : CES Number
    // -------------------------------------------------------
    const cesNumberLookup: Record<string, FAM.ICESNumber> = {};
    state?.data?.json.groupStructure.cesNumbers.forEach(eachCESNumber => {
        if (checkUniqueName) {
            if (!eachCESNumber.deactivated)
                if (eachCESNumber.cesNumber) {
                    const testCES = cesNumberLookup[eachCESNumber.cesNumber!];
                    if (testCES)
                        uniqueEntityNameValidations.push({
                            title: `CES Number(${eachCESNumber.cesNumber}) is not unique.`,
                            type: EValidationSeverity.error,
                            description: `This CES number has been defined multiple times in Group Structure\nYou may need to manage tool to merge the CES Number.`,
                        });
                    else
                        cesNumberLookup[eachCESNumber.cesNumber!] = eachCESNumber;
                }
        }
    });

    // Group Structure : Group Number
    // -------------------------------------------------------
    state?.data?.json.groupStructure.groupNumbers.forEach((eachGroupNumber) => {

        // map to array of master attributes, first element in array being the visible one and memoize so we only run it once if we need to access it multiple times
        const getFieldsMemo = getFieldsMemoByEntity(eachGroupNumber);

        // CES Number
        if (checkRef) {
            if (eachGroupNumber.cesNumberRef) {
                const foundCES = CESLookup[eachGroupNumber.cesNumberRef.id];

                if (!eachGroupNumber.deactivated)
                    if (!foundCES) {
                        refGroupNumberCESValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing an invalid CES Client Number(${eachGroupNumber.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nCES Client Number id: ${eachGroupNumber.cesNumberRef?.id}`,
                        });
                    }

                if (!eachGroupNumber.deactivated)
                    if (foundCES && foundCES.deactivated) {
                        refGroupNumberCESValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing a deactivated CES Client Number(${eachGroupNumber.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nCES Client Number id: ${eachGroupNumber.cesNumberRef?.id}`,
                        });
                    }
            }
        }

        // Plan
        if (checkRef) {
            if (eachGroupNumber.planRef) {
                const foundPlan = planLookup[eachGroupNumber.planRef.id];

                if (!eachGroupNumber.deactivated)
                    if (!foundPlan) {
                        refGroupNumberPlanValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing an invalid Plan(${eachGroupNumber.planRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nPlan id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }

                if (!eachGroupNumber.deactivated)
                    if (foundPlan && foundPlan.deactivated) {
                        refGroupNumberPlanValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing a deactivated Plan(${eachGroupNumber.planRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nPlan id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }
            }
        }

        // StopLoss
        if (checkRef) {
            if (eachGroupNumber.stopLossRef) {
                const foundStopLoss = stopLossLookup[eachGroupNumber.stopLossRef.id];

                if (!eachGroupNumber.deactivated)
                    if (!foundStopLoss) {
                        refGroupNumberStopLossValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing an invalid StopLoss(${eachGroupNumber.stopLossRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nStopLoss id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }

                if (!eachGroupNumber.deactivated)
                    if (foundStopLoss && foundStopLoss.deactivated) {
                        refGroupNumberStopLossValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing a deactivated StopLoss(${eachGroupNumber.stopLossRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nStopLoss id: ${eachGroupNumber.stopLossRef?.id}`,
                        });
                    }
            }
        }

        // Accounts Receivable
        if (checkRef) {
            if (eachGroupNumber.accountsReceivableRef) {
                const foundAccountsReceivableRef = accountsReceivableLookup[eachGroupNumber.accountsReceivableRef.id];

                if (!eachGroupNumber.deactivated)
                    if (!foundAccountsReceivableRef) {
                        refGroupNumberAccountsReceivableValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing an invalid Accounts Receivable(${eachGroupNumber.accountsReceivableRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nAccounts Receivable id: ${eachGroupNumber.planRef?.id}`,
                        });
                    }


                if (!eachGroupNumber.deactivated)
                    if (foundAccountsReceivableRef && foundAccountsReceivableRef.deactivated) {
                        refGroupNumberAccountsReceivableValidation.push({
                            title: `GroupNumber(${eachGroupNumber.groupNumber}) is referencing a deactivated Accounts Receivable(${eachGroupNumber.accountsReceivableRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `GroupNumber id: ${eachGroupNumber.id}\nAccounts Receivable id: ${eachGroupNumber.accountsReceivableRef?.id}`,
                        });
                    }
            }
        }

        // TODO this might need to be moved
        if (checkUniqueName) {
            // Group Number
            if (!eachGroupNumber.deactivated)
                if (eachGroupNumber.groupNumber) {
                    const testGN = groupNumbersLookup[eachGroupNumber.groupNumber!];
                    if (testGN && testGN.length > 1)
                        uniqueEntityNameValidations.push({
                            title: `Group Number(${eachGroupNumber.groupNumber}) is not unique.`,
                            type: EValidationSeverity.error,
                            description: `This Group Number has been used multiple times in Group Structure\nYou may need to change group number or deactivate one(s) that are no longer active.`,
                        });
                }

        }

        if (!eachGroupNumber.deactivated)
            if (!eachGroupNumber.groupNumber)
                refValidations.push({
                    title: `There is an instance of an invalid Group structure / Group Number without value.`,
                    type: EValidationSeverity.error,
                });

        if (!eachGroupNumber.deactivated)
            if (eachGroupNumber.planRef && eachGroupNumber.cesNumberRef) {
                const gpNumbers = planToCesToGN[eachGroupNumber.planRef.id] ?? {};
                gpNumbers[eachGroupNumber.cesNumberRef.id] = eachGroupNumber;
                planToCesToGN[eachGroupNumber.planRef.id] = gpNumbers;
            }


        // Validation Edit - Display a hard edit when the Subgroup or Benefit Cancellation Effective Date does not match the Effective Date of the Configuration
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/502867
        if (checkData) {
            if (!eachGroupNumber.deactivated) {
                if (eachGroupNumber?.status?.value === FAM.EBenefitStatus.Cancelled) {

                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=7086c361-d18d-ec11-b400-0022480a93ed
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=d67c1bc6-d18d-ec11-b400-0022480a93ed
                    const bcbs_cancellation = getFieldsMemo()['7086c361-d18d-ec11-b400-0022480a93ed'];

                    if (bcbs_cancellation) {

                        const bcbs_cancellation_value = bcbs_cancellation[0].field.values?.[0].value?.type === 'date'
                            ? bcbs_cancellation[0].field.values?.[0].value
                            : undefined;

                        const snapshotEffectiveDate = state.data.json.effectiveDate?.value;
                        const gnEffectiveDate = bcbs_cancellation_value?.value;

                        const gnEffectiveDateValue = gnEffectiveDate
                            ? formatDate(parseDate(gnEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                            : "(blank)";

                        const snapshotEffectiveDateValue = snapshotEffectiveDate
                            ? formatDate(parseDate(snapshotEffectiveDate, 'yyyy-MM-ddThh:mm:ssZ as local'), 'local:MM/dd/yyyy')
                            : "(blank)";

                        if (snapshotEffectiveDate !== gnEffectiveDate) {
                            dataValidations.push({
                                title: `The Group Number Cancellation Effective Date must match the Group Configuration Effective Date.`,
                                type: EValidationSeverity.error,
                                description: `Group Configuration Effective Date: ${snapshotEffectiveDateValue}\nGroup Number: ${eachGroupNumber.groupNumber}\nCancellation Effective Date: ${gnEffectiveDateValue}`,
                            });
                        }
                    }
                }

            }
        }



    });

    // Group Structure : Departments 
    // --------------------------------------------------------
    state?.data?.json.groupStructure.departments.forEach(eachDepartment => {

        // CES Number
        if (checkRef) {
            if (eachDepartment.cesNumberRef) {
                const foundCES = CESLookup[eachDepartment.cesNumberRef.id];

                if (!eachDepartment.deactivated)
                    if (!foundCES) {
                        refDepartmentCESValidation.push({
                            title: `Department(${eachDepartment.name}) is referencing an invalid CES Client Number(${eachDepartment.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Department id: ${eachDepartment.id}\nCES Client Number id: ${eachDepartment.cesNumberRef?.id}`,
                        });
                    }

                if (!eachDepartment.deactivated)
                    if (foundCES && foundCES.deactivated) {
                        refDepartmentCESValidation.push({
                            title: `Department(${eachDepartment.name}) is referencing a deactivated CES Client Number(${eachDepartment.cesNumberRef?.name ?? 'N/A'}).`,
                            type: EValidationSeverity.error,
                            description: `Department id: ${eachDepartment.id}\nCES Client Number id: ${eachDepartment.cesNumberRef?.id}`,
                        });
                    }
            }
        }

    });

    // Prevent submissions for more than one distinct client number for a given plan
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/305176
    if (checkPlanGroupStructure)
        for (const [planRefId, planCes] of Object.entries(planToCesToGN)) {
            if (Object.keys(planCes).length > 1) {
                const cesNumberList = [] as string[];

                // TODO build html table
                for (const [cesNumberRefid, groupNumber] of Object.entries(planCes)) {
                    cesNumberList.push(`Group Number: ${groupNumber.groupNumber}, CES Client Number: ${groupNumber?.cesNumberRef?.name}`);
                }

                const plan = planLookup[planRefId];
                if (!plan.deactivated)
                    planGroupStructureValidations.push({
                        title: `Plan(${plan.name}) is associated to more than one CES Client Number.`,
                        description: 'There is more than one Client Number associated to subgroups related to a singular Plan. A Plan should not have more than one Client Number for the associated subgroups.\n'
                            + cesNumberList.join('\n'),
                        type: EValidationSeverity.error,
                    });
            }
        }

    // Group Structure : Group Number : Second Part
    // -------------------------------------------------------
    if (refGroupNumberPlanValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated Plan.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberPlanValidation
        });
    }

    if (refGroupNumberCESValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated CES Number.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberCESValidation
        });
    }

    if (refGroupNumberStopLossValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated StopLoss.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberStopLossValidation
        });
    }

    if (refGroupNumberAccountsReceivableValidation.length > 0) {
        refValidations.push({
            title: `Some Group Number(s) are referencing an invalid / deactivated Accounts Receivable.`,
            type: EValidationSeverity.error,
            inner: refGroupNumberAccountsReceivableValidation
        });
    }

    if (refDepartmentCESValidation.length > 0) {
        refValidations.push({
            title: `Some Department(s) are referencing an invalid / deactivated CES Number.`,
            type: EValidationSeverity.error,
            inner: refDepartmentCESValidation
        });
    }

    // Fees And Premiums
    // -------------------------------------------------------
    // SBC - Produce "Warning" when generating a SBC where there are no Subgroups associated to the Plan
    // prevent a submission if plan is not marked as a non-billing and has no associated group number
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/322504
    // rolling back this for now, until a decision is made
    // if (checkBillingOnlyPlan)
    //     state?.data?.json?.plans?.forEach(eachPlan => {
    //         if (!eachPlan.deactivated)
    //             if (!eachPlan.billingOnlyPlan) {
    //                 const anyGroupNumber = planGroupNumberLookup[eachPlan.id];

    //                 if (!anyGroupNumber) {
    //                     billingOnlyPlanValidations.push({
    //                         title: `A Non - Billing Plan(${ eachPlan.name }) is missing a related Group Number.`,
    //                         description: `All active non - billing plans must have at least one related Group Number.\nIf this is a billing only plan, considering identifying under plan properties.`,
    //                         severity: EValidationSeverity.error,
    //                     });
    //                 }
    //             }
    //     });

    state?.data?.json.feesAndPremiums.forEach(eachFP => {

        const getFieldsMemo = getFieldsMemoByEntity(eachFP);

        // lets only build this if needed for the context
        let fieldMap: Record<string, FAM.IFlexibleField> | null = null;

        if (!fieldMap)
            if (checkCoverage)
                fieldMap = ArrayToLookupByPredicate(eachFP.fields, t => t.configRef.id);

        if (checkUniqueName)
            if (state.data.json.feesAndPremiums.some(eachTest => eachTest.name === eachFP.name && eachTest !== eachFP)) {
                uniqueEntityNameValidations.push({
                    title: `Fees And Premium(${eachFP.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Fees And Premium id: ${eachFP.id}`,
                });
            }

        if (checkCoverage)
            if (!eachFP.deactivated) {
                const coverageMap = CoverageMapping.map(t => {
                    const tt: ICoverageMapper = {
                        ...t,
                        fnp: eachFP,
                        fnp_fieldValue: null,
                    };

                    const field = fieldMap![t.fnp_attributeId];

                    if (field && field.values && field.values.length > 0) {
                        const fieldValue = (field.values[0].value as FAM.IBooleanValue);

                        if (fieldValue)
                            tt.fnp_fieldValue = fieldValue;
                    }

                    return tt;
                });

                feesAndPremiumsCoverages[eachFP.id] = coverageMap;
            }

        // fee config:
        const attributeSetFee = state.data.config.cache.map_bcbs_config_attribute['50d7c5a7-d590-ec11-b400-0022480a93ed'];

        let vmEachFee: IValidationMessage | null = null;

        eachFP.attributeSets.forEach(eachAttributeSets => {

            validateAttributeSet(eachAttributeSets, eachFP.attributeSets, { type: 'feesAndPremium', feesAndPremium: eachFP })

            let attributeSetFieldMap: Record<string, FAM.IFlexibleField> | null = null;

            if (!attributeSetFieldMap)
                if (checkCoverage)
                    attributeSetFieldMap = ArrayToLookupByPredicate(eachAttributeSets.fields, t => t.configRef.id);

            // TODO optimize this

            // 382827
            // if (checkUniqueName)
            //     if (eachFP.attributeSets.some(eachTest => eachTest.name === eachAS.name && eachTest !== eachAS)) {
            //         uniqueValidations.push({
            //             title: `Attributeset(${ eachAS.name }) on Fees And Premium(${ eachFP.name }) does not have a unique name.`,
            //             type: EValidationSeverity.warn,
            //             description: `Attributeset id: ${ eachAS.id }\r\nFees And Premium id: ${ eachFP.id }`,
            //         });
            //     }

            // Fees And Premium and Fee Detail Line coverage match
            // Coverage Tier rates identified on Fees MUST match the coverage tier settings on Fees and Premium 
            // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/260416
            if (checkCoverage) {
                if (!eachFP.deactivated && !eachAttributeSets.deactivated)
                    if (eachAttributeSets.attributeSetRef.id === attributeSetFee._bcbs_config_masterattributeid_value) {
                        // validating on fee attribute set
                        if (attributeSetFieldMap) {

                            const bccAdminField = attributeSetFieldMap[bcbs_config_attributeid_BCCAdmin];

                            const feeTypeField = attributeSetFieldMap[bcbs_config_attributeid_FeeType];

                            const bccAdminFieldValue = bccAdminField?.values?.[0]?.value as FAM.IEntityReferenceValue;
                            const feeTypeFieldValue = feeTypeField?.values?.[0]?.value as FAM.IEntityReferenceValue;

                            if (feeTypeFieldValue && feeTypeFieldValue.id === pepmFeeType.id)
                                if (bccAdminFieldValue) {
                                    // lets find the category selected in bcc admin
                                    const bccAdmin = state.data.config.cache.map_bcbs_bccadmin[bccAdminFieldValue.id];

                                    if (!bccAdmin._bcbs_categoryid_value)
                                        throw new Error("bad data");

                                    const category = state.data.config.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];

                                    if (!category)
                                        throw new Error("bad data");

                                    const coverageMappingByCategory = CoverageMapping.filter(q => q.fnp_fee_bccAdminCategory === category.bcbs_name);

                                    const coverageMappingLocal = coverageMappingByCategory.map(t => {
                                        const tt = { ...t };
                                        // Fees and Premium
                                        {
                                            const field = fieldMap![t.fnp_attributeId];

                                            tt.fnp_attributeId = field.configRef.id;

                                            if (field && field.values && field.values.length > 0) {
                                                const fieldValue = (field.values[0].value as FAM.IBooleanValue);

                                                if (fieldValue)
                                                    tt.fnp_fieldValue = fieldValue;
                                            }

                                        }

                                        // Fees and Premium - Attribute Set
                                        {
                                            const field = attributeSetFieldMap![t.fnp_fee_attributeId];
                                            const value = field?.values?.[0]?.value as FAM.INumberValue;

                                            tt.fnp_fee = eachAttributeSets;
                                            tt.fnp_fee_attributeId = field.configRef.id;
                                            tt.fnp_fee_fieldValue = value;
                                        }

                                        return tt;
                                    });

                                    let vm: IValidationMessage | null = null;

                                    coverageMappingLocal.forEach(eachX => {

                                        let badCoverage = false;

                                        // if coverage is set, but there is no value
                                        badCoverage = badCoverage || eachX.fnp_fieldValue?.value === true && (!eachX.fnp_fee_fieldValue?.value && eachX.fnp_fee_fieldValue?.value !== 0);

                                        // it coverage is not set, but there is a value 
                                        badCoverage = badCoverage || (!eachX.fnp_fieldValue?.value && (!!eachX.fnp_fee_fieldValue?.value || eachX.fnp_fee_fieldValue?.value === 0));

                                        if (badCoverage) {

                                            const attribute_fnp_fee = state.data.config.cache.map_bcbs_config_attribute[eachX.fnp_fee_attributeId];
                                            const attribute_fnp = state.data.config.cache.map_bcbs_config_attribute[eachX.fnp_attributeId];

                                            if (!vmEachFee) {

                                                vmEachFee = {
                                                    title: `Coverage mismatch on Fees And Premium(${eachFP.name}) and related Fees.`,
                                                    type: EValidationSeverity.error,
                                                    inner: []
                                                }

                                                coverageValidations.push(vmEachFee);
                                            }

                                            if (!vm) {

                                                vm = {
                                                    title: `Fees And Premium(${eachFP.name}) and Fee(${eachAttributeSets.name}) coverage does not match.`,
                                                    type: EValidationSeverity.error,
                                                    inner: []
                                                }

                                                vmEachFee.inner?.push(vm);
                                            }

                                            vm.inner?.push({
                                                title: `Field(${attribute_fnp_fee.bcbs_name}) does not match the specified coverage.`,
                                                type: EValidationSeverity.error,
                                                description: `Attributeset: ${eachAttributeSets.name}\nField: ${attribute_fnp_fee.bcbs_name}\nValue: ${eachX.fnp_fee_fieldValue?.value}\n\nFees And Premium: ${eachFP.name}) \nField: ${attribute_fnp.bcbs_name} \nValue: ${eachX.fnp_fieldValue?.value} `,
                                                inner: []
                                            })
                                        }
                                    })
                                }
                        }
                    }
            }
        });
    });

    // Plan and Fees And Premium coverage match
    // 260416 - Coverage Tier settings on Plan MUST match the coverage tiers settings on Fees and Premium
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/260416
    if (checkCoverage) {
        for (const key in plansCoverageFields) {
            const planCoverage = plansCoverageFields[key];

            let planError: IValidationMessage | null = null;

            planCoverage.forEach((eachPlanCoverage, index) => {

                const fnpCoverage = feesAndPremiumsCoverages[eachPlanCoverage.plan?.feesAndPremiumsRef?.id!]
                const eachFnpCoverage = fnpCoverage[index];

                const attributePlan = state.data.config.cache.map_bcbs_config_attribute[eachPlanCoverage.plan_attributeId];
                const attributeFee = state.data.config.cache.map_bcbs_config_attribute[eachFnpCoverage.fnp_attributeId];

                let feeError: IValidationMessage[] = [];

                if (eachPlanCoverage.plan_fieldValue?.value !== eachFnpCoverage.fnp_fieldValue?.value) {

                    if (!planError)
                        planError = {
                            title: `Plan(${eachPlanCoverage.plan?.name}) and related Fees And Premium(${eachFnpCoverage.fnp?.name}) coverage does not match.`,
                            type: EValidationSeverity.error,
                            description: `Coverage tiers for plan and related Fees And Premium setup must exactly match.`,
                            inner: []
                        }

                    planError.inner?.push({
                        title: `Coverage mismatch on field(${attributePlan.bcbs_name}).`,
                        type: EValidationSeverity.error,
                        description: `Plan Coverage Field: ${attributePlan.bcbs_name} \nValue: ${eachPlanCoverage.plan_fieldValue?.value} \n\nFee Coverage Field: ${attributeFee.bcbs_name} \nValue: ${eachFnpCoverage.fnp_fieldValue?.value} `,
                    });
                }
            });

            if (planError)
                coverageValidations.push(planError);
        }
    }

    // Account Receivable / Claims AR ---
    // -------------------------------------------------------
    state?.data?.json.claimsARs.forEach(eachAccountsReceivable => {

        const getFieldsMemo = getFieldsMemoByEntity(eachAccountsReceivable);

        if (checkUniqueName)
            if (state.data.json.claimsARs.some(eachTest => eachTest.name === eachAccountsReceivable.name && eachTest !== eachAccountsReceivable)) {
                uniqueEntityNameValidations.push({
                    title: `Accounts Receivable(${eachAccountsReceivable.name}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `Accounts Receivable id: ${eachAccountsReceivable.id} `,
                });
            }

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/375442
        if (checkRelatedToGroupNumber)
            if (!eachAccountsReceivable.deactivated)
                if (!groupNumbersByAccountsReceivableIdLookup[eachAccountsReceivable.id]) {
                    relatedToGroupNumberValidations.push({
                        title: `Accounts Receivable(${eachAccountsReceivable.name}) is not related to any Group Numbers.`,
                        type: EValidationSeverity.warn,
                        description: `Accounts Receivable id: ${eachAccountsReceivable.id} `,
                    });
                }


        // Fees and Premiums - Shared Savings - New fields in Shared Savings Attribute Set
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/516907
        if (checkData) {
            const accountsReceivableRelations = accountsReceivable_to_feesAndPremiums[eachAccountsReceivable.id];

            // AR CE Cap Amount (master)
            // Claims Edit Cap Amount
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=3e347f02-8d4a-ef11-a317-000d3a17460e
            // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=5fde294b-8d4a-ef11-a317-000d3a17460e
            const bcbs_cecapamount_ar = getFieldsMemo()['3e347f02-8d4a-ef11-a317-000d3a17460e'];
            const bcbs_cecapamount_ar_value = bcbs_cecapamount_ar?.[0]?.field?.values?.[0]?.value?.type === 'number'
                ? (bcbs_cecapamount_ar?.[0]?.field?.values?.[0]?.value)
                : null;

            accountsReceivableRelations?.forEach(eachRelation => {

                // any of relationship is deactivated, skip
                if (eachRelation.plan.deactivated || eachRelation.accountsReceivable.deactivated || eachRelation.feesAndPremium.deactivated)
                    return;

                // new cap amount field on AR doesn`t exist, skip
                if (!bcbs_cecapamount_ar)
                    return;

                // we need to compare each individual shared savings attribute set with accounts receivable, to make sure its compliant
                eachRelation.feesAndPremium.attributeSets.forEach(eachAttributeSet => {

                    // Fees And Premium - Shared Savings - Attribute Set Fields:
                    const getOtherFieldsMemo = getFieldsMemoByEntity(eachAttributeSet);

                    if (eachAttributeSet.deactivated)
                        return;

                    // Shared Savings / Attribute Set
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=296bac98-575e-ee11-be6f-000d3a3bec27
                    // not shared saving attribute set? skip
                    if (eachAttributeSet.attributeSetRef.id !== '296bac98-575e-ee11-be6f-000d3a3bec27')
                        return;

                    // Shared Savings Category
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=2b6bac98-575e-ee11-be6f-000d3a3bec27
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=7b606da3-585e-ee11-be6f-000d3a3bec27
                    const bcbs_sharedsavings_categorycode = getOtherFieldsMemo()['2b6bac98-575e-ee11-be6f-000d3a3bec27'];
                    const bcbs_sharedsavings_categorycode_value = bcbs_sharedsavings_categorycode?.[0].field?.values?.[0]?.value?.type === 'entity'
                        ? bcbs_sharedsavings_categorycode[0].field.values[0].value
                        : null;

                    // Claims Edits ?
                    // "entity/bcbs_config_optionsetitem/Claims Edits/af7e9d03-565e-ee11-be71-000d3a3be219"
                    // shared saving claim type is not set to claims edit? skip
                    if (bcbs_sharedsavings_categorycode_value?.id !== 'af7e9d03-565e-ee11-be71-000d3a3be219')
                        return;

                    // Cap Amount
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=356bac98-575e-ee11-be6f-000d3a3bec27
                    // https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=8b606da3-585e-ee11-be6f-000d3a3bec27
                    const bcbs_sharedsavings_capamount = getOtherFieldsMemo()['356bac98-575e-ee11-be6f-000d3a3bec27'];
                    const bcbs_sharedsavings_capamount_value = bcbs_sharedsavings_capamount?.[0].field?.values?.[0]?.value?.type === 'number'
                        ? bcbs_sharedsavings_capamount[0].field.values[0].value
                        : null;

                    // if no AR cap amount
                    // if no FNP-SharedSaving-ClaimEdit cap amount - if no shared savings claim edit cap amount
                    // if bad cap amount - different shared savings claim edit cap amount compared to AR cap amount
                    if (!bcbs_cecapamount_ar_value || !bcbs_sharedsavings_capamount_value || bcbs_cecapamount_ar_value?.value !== bcbs_sharedsavings_capamount_value?.value) {
                        dataValidations.push({
                            title: `Claims Edit Cap Amounts must match.`,
                            type: EValidationSeverity.error,
                            description: `A discrepancy has been detected in the Claims Edit Cap amounts on Accounts Receivable, as well as the associated Fees And Premiums, Shared Savings attributeset, based on the Plan/Group Number relationship.\n\nPlan: ${eachRelation.plan.name}\nGroup Number: ${eachRelation.lastGroupNumber.groupNumber}\nAccounts Receivable: ${eachAccountsReceivable.name} \nFees And Premium: ${eachRelation.feesAndPremium.name}\nShared Savings: ${eachAttributeSet.name}\nAccounts Receivable Cap Amount: ${bcbs_cecapamount_ar_value?.value} \nShared Savings Cap Amount: ${bcbs_sharedsavings_capamount_value?.value}`,
                        });
                    }

                });

            });
        }

        eachAccountsReceivable.attributeSets.forEach(eachAttributeSet => {
            validateAttributeSet(eachAttributeSet, eachAccountsReceivable.attributeSets, { type: 'accountsReceivable', accountsReceivable: eachAccountsReceivable });
        })

    });

    // Stop Loss ---
    // -------------------------------------------------------
    state?.data?.json.stopLoss.forEach(eachStopLoss => {

        if (checkUniqueName)
            if (state.data.json.stopLoss.some(eachTest => eachTest.name === eachStopLoss.name && eachTest !== eachStopLoss)) {
                uniqueEntityNameValidations.push({
                    title: `StopLoss(${eachStopLoss.name} / ${eachStopLoss.id}) does not have a unique name.`,
                    type: EValidationSeverity.error,
                    description: `StopLoss id: ${eachStopLoss.id} `,
                });
            }

        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/375442
        if (checkRelatedToGroupNumber) {
            if (!eachStopLoss.deactivated && !groupNumbersByStopLossIdLookup[eachStopLoss.id]) {
                relatedToGroupNumberValidations.push({
                    title: `Stop Loss (${eachStopLoss.name}) is not related to any Group Numbers.`,
                    type: EValidationSeverity.warn,
                    description: `Stop Loss id: ${eachStopLoss.id}`,
                });
            }
        }

        eachStopLoss.attributeSets.forEach(eachAttributeSet => {
            validateAttributeSet(eachAttributeSet, eachStopLoss.attributeSets, { type: 'stopLoss', stopLoss: eachStopLoss });
        });

    });

    // Other ---
    // -------------------------------------------------------
    // Not latest release message should only display on Group Configurations which are not yet UWRC
    // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/390788
    if (checkRelease)
        if (state.data.config.bcbs_config_release?.statuscode !== bcbs_config_release.statuscode["Published(2)"].value)
            if (!snapshot_statuscode_post_uwrc) {
                // we could have used : !state.data.snapshot.bcbs_underwritingreviewcompletedate MUal mentioned this would not have been comprehensive enough
                releaseValidations.push({
                    title: `Configuration is not using the latest published release.`,
                    description: `Present configuration does not encompass the latest update.\nTo ensure optimal functionality, it is recommended to select the Save > Update Release option to apply the configuration updates.\nPlease be advised that selecting this option will result in copying the current configuration into a new configuration on the latest published release. The current configuration will then be deactivated.`,
                    type: context === EDataValidationContext.ESaveSubmit ? EValidationSeverity.error : EValidationSeverity.info,
                });
            }

    return resultValidations;
}